<template>
  <div class="scrolltotop">
    <a class="button-circle button-circle-sm button-circle-dark" href="#">
      <font-awesome-icon :icon="['fa', 'arrow-up']" />
    </a>
  </div>
</template>

<script>
import JQuery from "jquery";
import 'jquery.easing';
const $ = JQuery;

export default {
  mounted() {
    /*===============================================
      Scroll to top button
    ===============================================*/
      
    var scrollTopBtn = $(".scrolltotop");

    $(window).on("scroll", function() {
      if ($(this).scrollTop() > 700) {
        // 700px from top
        scrollTopBtn.addClass("scrolltotop-show");
      } else {
        scrollTopBtn.removeClass("scrolltotop-show");
      }
    });

    // Animate button
    var htmlBody = $("html,body");
    var ssBtn = $(".scrolldown-btn, .scrolldown"); // , .navbar a");

    scrollTopBtn.on("click", function() {
      htmlBody.animate({ scrollTop: 0 }, 600, "easeInOutQuart");
      return false;
    });
  }
};
</script>